import React from "react";
import { Grid, Typography, Box } from "@material-ui/core";

interface ExternSurfaceProps {
    title: string;
    description?: string;
    children: React.ReactNode;
    showTitle?: boolean;
    sm?: true | "auto" | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    md?: true | "auto" | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    lg?: true | "auto" | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
    xl?: true | "auto" | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
}

export default function ExternSurface(props: ExternSurfaceProps) {
    return (
        <Grid item xs={12} sm={props.sm || 10} md={props.md || 6} lg={props.lg || 4} xl={props.xl || 3}>
            <Box my={4}>
                <Grid container justify="center" alignItems="center">
                    <Grid item xs={11} lg={12}>
                        <Grid container justify="center" alignItems="center">
                            <img src="/logo.png" alt="logo" className="ExternLogo" />
                            <Grid item xs={12}>
                                {props.showTitle && props.title && (
                                    <Box mb={3}>
                                        <Typography component="h5" variant="h5" align="center">
                                            {props.title}
                                        </Typography>
                                    </Box>
                                )}
                                {props.description && (
                                    <Typography component="p" variant="body1" align="center">
                                        {props.description}
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                        {props.children}
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
}